import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const SubscriberDetailHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="CONGESTION & ACM Metrics"
      onClose={doClose}
      content={() => (
        <>
          This page shows average measurements related to congestion for the
          whole network. Shows current information and statistics for the
          subscriber with the selected IP address.
          <ul>
            <li>
              Click on the refresh{" "}
              <i className="material-icons valign-icon">refresh</i> icon to
              reload page.
            </li>
          </ul>
          <p>Select the period for the statistics (from 1 day to 3 months)</p>
          The graphs show:
          <ul>
            <li>
              <b>
              Average traffic under congestion and with ACM:
              </b>{" "}
              The average percent of
              total downlink traffic that is detected as congested (high losses
              or high latency due to high speed) and the average of total
              download traffic that is being limited by the ACM functionality
            </li>
            <li>
            <b>Latency over time:</b> 
              RTT (Round-trip time) latency over time, measured with TCP acknowledgements, from the time data packets leave this node towards the end user until the acknowledgements are received by this node. It does not include the latency from this node to the servers in Internet. <br />
              If "P80-80th percentile" is selected, each measurement is the 80-th percentile of all downlink RTT latency samples in 5 minutes. <br />
              If "P50-Median" is selected, each measurement is the 50-th percentile (the median) of all downlink RTT latency samples in 5 minutes. <br />
              If "Mean-Min" is selected, each measurement is mean of all downlink RTT minimum latency samples, measured in 1-second intervals, during active downloads, in 5 minutes. If "All" is selected, all the previous metrics are shown.
            </li>
            <li>
              <b>Average TCP Retransmissions Over Time:</b> average TCP
              retransmissions for all users over time. This value is very
              related to the amount of packet losses, and it is measured for
              packets retransmitted from this node towards the users in the
              access side.
            </li>
            <li>
              <b>Total Throughput:</b> total throughput over time.
            </li>
          </ul>
        </>
      )}
    />
  );
};
export default SubscriberDetailHelpModal;
